// Static data for countries, country codes, and cities
export const countriesData = [
    {
        name: "United States",
        iso2: "US",
        dial_code: "+1",
        cities: ["New York", "Los Angeles", "Chicago", "Houston", "Phoenix", "Philadelphia", "San Antonio", "San Diego", "Dallas", "San Jose", "Austin", "Jacksonville", "Fort Worth", "Columbus", "Charlotte", "San Francisco", "Indianapolis", "Seattle", "Denver", "Washington", "Boston", "El Paso", "Nashville", "Detroit", "Oklahoma City", "Portland", "Las Vegas", "Memphis", "Louisville", "Baltimore", "Milwaukee", "Albuquerque", "Tucson", "Fresno", "Sacramento", "Kansas City", "Mesa", "Atlanta", "Omaha", "Colorado Springs", "Raleigh", "Miami", "Long Beach", "Virginia Beach", "Oakland", "Minneapolis", "Tampa", "Tulsa", "Arlington", "New Orleans"]
    },
    {
        name: "Canada",
        iso2: "CA",
        dial_code: "+1",
        cities: ["Toronto", "Montreal", "Vancouver", "Calgary", "Edmonton", "Ottawa", "Winnipeg", "Quebec City", "Hamilton", "Kitchener", "London", "Victoria", "Halifax", "Oshawa", "Windsor", "Saskatoon", "Regina", "St. Catharines", "Barrie", "Kelowna", "Abbotsford", "Kingston", "Sudbury", "Saguenay", "Sherbrooke", "Guelph", "Thunder Bay", "Brantford"]
    },
    {
        name: "United Kingdom",
        iso2: "GB",
        dial_code: "+44",
        cities: ["London", "Birmingham", "Manchester", "Glasgow", "Liverpool", "Leeds", "Sheffield", "Edinburgh", "Bristol", "Leicester", "Coventry", "Bradford", "Cardiff", "Belfast", "Nottingham", "Kingston upon Hull", "Newcastle upon Tyne", "Stoke-on-Trent", "Southampton", "Derby", "Portsmouth", "Brighton", "Plymouth", "Northampton", "Reading", "Luton", "Wolverhampton", "Bolton", "Aberdeen", "Bournemouth", "Norwich", "Swindon", "Swansea", "Milton Keynes", "Southend-on-Sea", "Middlesbrough", "Peterborough", "Cambridge", "Oxford", "York", "Ipswich", "Exeter", "Gloucester", "Bath"]
    },
    {
        name: "Germany",
        iso2: "DE",
        dial_code: "+49",
        cities: ["Berlin", "Hamburg", "Munich", "Cologne", "Frankfurt", "Stuttgart", "Düsseldorf", "Dortmund", "Essen", "Leipzig", "Bremen", "Dresden", "Hanover", "Nuremberg", "Duisburg", "Bochum", "Wuppertal", "Bielefeld", "Bonn", "Münster", "Karlsruhe", "Mannheim", "Augsburg", "Wiesbaden", "Gelsenkirchen", "Mönchengladbach", "Braunschweig", "Chemnitz", "Kiel", "Aachen", "Halle", "Magdeburg", "Freiburg", "Krefeld", "Lübeck", "Oberhausen", "Erfurt", "Mainz", "Rostock", "Kassel"]
    },
    {
        name: "France",
        iso2: "FR",
        dial_code: "+33",
        cities: ["Paris", "Marseille", "Lyon", "Toulouse", "Nice", "Nantes", "Strasbourg", "Montpellier", "Bordeaux", "Lille", "Rennes", "Reims", "Le Havre", "Saint-Étienne", "Toulon", "Grenoble", "Dijon", "Angers", "Nîmes", "Villeurbanne", "Saint-Denis", "Le Mans", "Aix-en-Provence", "Clermont-Ferrand", "Brest", "Limoges", "Tours", "Amiens", "Perpignan", "Metz", "Besançon", "Boulogne-Billancourt", "Orléans", "Mulhouse", "Rouen", "Caen", "Nancy", "Saint-Paul", "Argenteuil", "Montreuil"]
    },
    {
        name: "Italy",
        iso2: "IT",
        dial_code: "+39",
        cities: ["Rome", "Milan", "Naples", "Turin", "Palermo", "Genoa", "Bologna", "Florence", "Bari", "Catania", "Venice", "Verona", "Messina", "Padua", "Trieste", "Taranto", "Brescia", "Parma", "Prato", "Modena", "Reggio Calabria", "Reggio Emilia", "Perugia", "Livorno", "Ravenna", "Cagliari", "Foggia", "Rimini", "Salerno", "Ferrara", "Sassari", "Latina", "Giugliano in Campania", "Monza", "Syracuse", "Pescara", "Bergamo", "Forlì", "Trento", "Vicenza"]
    },
    {
        name: "Spain",
        iso2: "ES",
        dial_code: "+34",
        cities: ["Madrid", "Barcelona", "Valencia", "Seville", "Zaragoza", "Málaga", "Murcia", "Palma", "Las Palmas", "Bilbao", "Alicante", "Córdoba", "Valladolid", "Vigo", "Gijón", "L'Hospitalet de Llobregat", "A Coruña", "Granada", "Vitoria-Gasteiz", "Elche", "Oviedo", "Santa Cruz de Tenerife", "Badalona", "Cartagena", "Terrassa", "Jerez de la Frontera", "Sabadell", "Móstoles", "Alcalá de Henares", "Pamplona", "Fuenlabrada", "Almería", "Leganés", "Santander", "Burgos", "Castellón de la Plana", "Albacete", "Alcorcón", "Getafe", "Salamanca"]
    },
    {
        name: "Netherlands",
        iso2: "NL",
        dial_code: "+31",
        cities: ["Amsterdam", "Rotterdam", "The Hague", "Utrecht", "Eindhoven", "Tilburg", "Groningen", "Almere", "Breda", "Nijmegen", "Enschede", "Haarlem", "Arnhem", "Zaanstad", "Amersfoort", "Apeldoorn", "'s-Hertogenbosch", "Hoofddorp", "Maastricht", "Leiden", "Dordrecht", "Zoetermeer", "Zwolle", "Deventer", "Delft", "Alkmaar", "Heerlen", "Venlo", "Leeuwarden"]
    },
    {
        name: "Belgium",
        iso2: "BE",
        dial_code: "+32",
        cities: ["Brussels", "Antwerp", "Ghent", "Charleroi", "Liège", "Bruges", "Namur", "Leuven", "Mons", "Aalst", "Mechelen", "La Louvière", "Kortrijk", "Hasselt", "Ostend", "Sint-Niklaas", "Tournai", "Genk", "Seraing", "Roeselare"]
    },
    {
        name: "Switzerland",
        iso2: "CH",
        dial_code: "+41",
        cities: ["Zurich", "Geneva", "Basel", "Lausanne", "Bern", "Winterthur", "Lucerne", "St. Gallen", "Lugano", "Biel/Bienne", "Thun", "Köniz", "La Chaux-de-Fonds", "Schaffhausen", "Fribourg", "Chur", "Vernier", "Neuchâtel", "Uster", "Sion"]
    },
    {
        name: "Austria",
        iso2: "AT",
        dial_code: "+43",
        cities: ["Vienna", "Graz", "Linz", "Salzburg", "Innsbruck", "Klagenfurt", "Villach", "Wels", "Sankt Pölten", "Dornbirn", "Wiener Neustadt", "Steyr", "Feldkirch", "Bregenz", "Leonding", "Klosterneuburg", "Baden", "Wolfsberg", "Leoben", "Traun"]
    },
    {
        name: "Poland",
        iso2: "PL",
        dial_code: "+48",
        cities: ["Warsaw", "Kraków", "Łódź", "Wrocław", "Poznań", "Gdańsk", "Szczecin", "Bydgoszcz", "Lublin", "Katowice", "Białystok", "Gdynia", "Częstochowa", "Radom", "Sosnowiec", "Toruń", "Kielce", "Gliwice", "Zabrze", "Olsztyn", "Rzeszów", "Bielsko-Biała", "Bytom", "Zielona Góra", "Ruda Śląska"]
    },
    {
        name: "Czech Republic",
        iso2: "CZ",
        dial_code: "+420",
        cities: ["Prague", "Brno", "Ostrava", "Plzeň", "Liberec", "Olomouc", "Ústí nad Labem", "České Budějovice", "Hradec Králové", "Pardubice", "Havířov", "Zlín", "Kladno", "Most", "Opava", "Frýdek-Místek", "Jihlava", "Teplice", "Karviná", "Děčín"]
    },
    {
        name: "Portugal",
        iso2: "PT",
        dial_code: "+351",
        cities: ["Lisbon", "Porto", "Vila Nova de Gaia", "Amadora", "Braga", "Funchal", "Coimbra", "Setúbal", "Almada", "Agualva-Cacém", "Queluz", "Rio de Mouro", "Odivelas", "Loures", "Évora", "Rio Tinto", "Aveiro", "Barreiro", "São Domingos de Rana", "Leiria"]
    },
    {
        name: "Greece",
        iso2: "GR",
        dial_code: "+30",
        cities: ["Athens", "Thessaloniki", "Patras", "Piraeus", "Heraklion", "Larissa", "Volos", "Rhodes", "Ioannina", "Chania", "Chalcis", "Agrinio", "Kalamata", "Katerini", "Kavala", "Lamia", "Serres", "Alexandroupoli", "Xanthi", "Kozani"]
    },
    {
        name: "Sweden",
        iso2: "SE",
        dial_code: "+46",
        cities: ["Stockholm", "Gothenburg", "Malmö", "Uppsala", "Västerås", "Örebro", "Linköping", "Helsingborg", "Jönköping", "Norrköping", "Lund", "Umeå", "Gävle", "Borås", "Södertälje", "Eskilstuna", "Halmstad", "Växjö", "Karlstad", "Sundsvall"]
    },
    {
        name: "Norway",
        iso2: "NO",
        dial_code: "+47",
        cities: ["Oslo", "Bergen", "Stavanger", "Trondheim", "Drammen", "Fredrikstad", "Kristiansand", "Sandnes", "Tromsø", "Sarpsborg", "Skien", "Ålesund", "Sandefjord", "Haugesund", "Tønsberg", "Moss", "Porsgrunn", "Bodø", "Arendal", "Hamar"]
    },
    {
        name: "Denmark",
        iso2: "DK",
        dial_code: "+45",
        cities: ["Copenhagen", "Aarhus", "Odense", "Aalborg", "Frederiksberg", "Esbjerg", "Randers", "Kolding", "Horsens", "Vejle", "Roskilde", "Herning", "Silkeborg", "Næstved", "Fredericia", "Viborg", "Køge", "Holstebro", "Taastrup", "Slagelse"]
    },
    {
        name: "Finland",
        iso2: "FI",
        dial_code: "+358",
        cities: ["Helsinki", "Espoo", "Tampere", "Vantaa", "Oulu", "Turku", "Jyväskylä", "Lahti", "Kuopio", "Kouvola", "Pori", "Joensuu", "Lappeenranta", "Hämeenlinna", "Vaasa", "Rovaniemi", "Seinäjoki", "Mikkeli", "Kotka", "Salo"]
    },
    {
        name: "Ireland",
        iso2: "IE",
        dial_code: "+353",
        cities: ["Dublin", "Cork", "Limerick", "Galway", "Waterford", "Drogheda", "Dundalk", "Swords", "Bray", "Navan", "Ennis", "Kilkenny", "Carlow", "Tralee", "Newbridge", "Naas", "Athlone", "Portlaoise", "Mullingar", "Wexford"]
    },
    {
        name: "Russia",
        iso2: "RU",
        dial_code: "+7",
        cities: ["Moscow", "Saint Petersburg", "Novosibirsk", "Yekaterinburg", "Nizhny Novgorod", "Kazan", "Chelyabinsk", "Omsk", "Samara", "Rostov-on-Don", "Ufa", "Krasnoyarsk", "Voronezh", "Perm", "Volgograd", "Krasnodar", "Saratov", "Tyumen", "Tolyatti", "Izhevsk"]
    },
    {
        name: "Ukraine",
        iso2: "UA",
        dial_code: "+380",
        cities: ["Kyiv", "Kharkiv", "Odessa", "Dnipro", "Donetsk", "Zaporizhzhia", "Lviv", "Kryvyi Rih", "Mykolaiv", "Mariupol", "Luhansk", "Sevastopol", "Vinnytsia", "Makiivka", "Simferopol", "Kherson", "Poltava", "Chernihiv", "Cherkasy", "Zhytomyr"]
    },
    {
        name: "Turkey",
        iso2: "TR",
        dial_code: "+90",
        cities: ["Istanbul", "Ankara", "Izmir", "Bursa", "Adana", "Gaziantep", "Konya", "Antalya", "Kayseri", "Mersin", "Eskişehir", "Diyarbakır", "Samsun", "Denizli", "Şanlıurfa", "Adapazarı", "Malatya", "Kahramanmaraş", "Erzurum", "Van"]
    },
    {
        name: "Georgia",
        iso2: "GE",
        dial_code: "+995",
        cities: ["Tbilisi", "Batumi", "Kutaisi", "Rustavi", "Zugdidi", "Gori", "Poti", "Khashuri", "Samtredia", "Senaki", "Zestafoni", "Marneuli", "Telavi", "Akhaltsikhe", "Kobuleti", "Ozurgeti", "Kaspi", "Chiatura", "Tsqaltubo", "Akhalkalaki", "Bolnisi", "Gardabani", "Mtskheta", "Khoni", "Sagarejo"]
    },
    {
        name: "Armenia",
        iso2: "AM",
        dial_code: "+374",
        cities: ["Yerevan", "Gyumri", "Vanadzor", "Vagharshapat", "Hrazdan", "Abovyan", "Kapan", "Armavir", "Gavar", "Artashat", "Goris", "Charentsavan", "Ashtarak", "Sevan", "Ararat", "Ijevan", "Yeghvard", "Spitak", "Metsamor", "Dilijan"]
    },
    {
        name: "Azerbaijan",
        iso2: "AZ",
        dial_code: "+994",
        cities: ["Baku", "Ganja", "Sumqayit", "Mingachevir", "Lankaran", "Nakhchivan", "Shirvan", "Shaki", "Yevlakh", "Khankendi", "Agdam", "Aghjabadi", "Khachmaz", "Quba", "Qazakh", "Barda", "Sabirabad", "Salyan", "Bilasuvar", "Shamakhi"]
    },
    {
        name: "Japan",
        iso2: "JP",
        dial_code: "+81",
        cities: ["Tokyo", "Yokohama", "Osaka", "Nagoya", "Sapporo", "Fukuoka", "Kobe", "Kyoto", "Kawasaki", "Saitama", "Hiroshima", "Sendai", "Chiba", "Kitakyushu", "Sakai", "Niigata", "Hamamatsu", "Shizuoka", "Sagamihara", "Okayama"]
    },
    {
        name: "China",
        iso2: "CN",
        dial_code: "+86",
        cities: ["Shanghai", "Beijing", "Chongqing", "Tianjin", "Guangzhou", "Shenzhen", "Wuhan", "Dongguan", "Chengdu", "Nanjing", "Hong Kong", "Shenyang", "Hangzhou", "Xi'an", "Harbin", "Suzhou", "Qingdao", "Dalian", "Zhengzhou", "Shantou"]
    },
    {
        name: "South Korea",
        iso2: "KR",
        dial_code: "+82",
        cities: ["Seoul", "Busan", "Incheon", "Daegu", "Daejeon", "Gwangju", "Suwon", "Ulsan", "Changwon", "Goyang", "Yongin", "Seongnam", "Bucheon", "Cheongju", "Ansan", "Jeonju", "Anyang", "Pohang", "Cheonan", "Namyangju"]
    },
    {
        name: "India",
        iso2: "IN",
        dial_code: "+91",
        cities: ["Mumbai", "Delhi", "Bangalore", "Hyderabad", "Ahmedabad", "Chennai", "Kolkata", "Surat", "Pune", "Jaipur", "Lucknow", "Kanpur", "Nagpur", "Indore", "Thane", "Bhopal", "Visakhapatnam", "Pimpri-Chinchwad", "Patna", "Vadodara", "Ghaziabad", "Ludhiana", "Agra", "Nashik", "Faridabad", "Meerut", "Rajkot", "Kalyan-Dombivali", "Vasai-Virar", "Varanasi"]
    },
    {
        name: "Pakistan",
        iso2: "PK",
        dial_code: "+92",
        cities: ["Karachi", "Lahore", "Faisalabad", "Rawalpindi", "Multan", "Gujranwala", "Hyderabad", "Peshawar", "Quetta", "Islamabad", "Bahawalpur", "Sargodha", "Sialkot", "Sukkur", "Larkana", "Sheikhupura", "Rahim Yar Khan", "Jhang", "Dera Ghazi Khan", "Gujrat"]
    },
    {
        name: "Australia",
        iso2: "AU",
        dial_code: "+61",
        cities: ["Sydney", "Melbourne", "Brisbane", "Perth", "Adelaide", "Gold Coast", "Newcastle", "Canberra", "Sunshine Coast", "Wollongong", "Hobart", "Geelong", "Townsville", "Cairns", "Darwin", "Toowoomba", "Ballarat", "Bendigo", "Albury", "Launceston"]
    },
    {
        name: "New Zealand",
        iso2: "NZ",
        dial_code: "+64",
        cities: ["Auckland", "Wellington", "Christchurch", "Hamilton", "Tauranga", "Napier-Hastings", "Dunedin", "Palmerston North", "Nelson", "Rotorua", "New Plymouth", "Whangarei", "Invercargill", "Whanganui", "Gisborne", "Timaru", "Pukekohe", "Masterton", "Levin", "Taupo"]
    },
    {
        name: "Brazil",
        iso2: "BR",
        dial_code: "+55",
        cities: ["São Paulo", "Rio de Janeiro", "Brasília", "Salvador", "Fortaleza", "Belo Horizonte", "Manaus", "Curitiba", "Recife", "Porto Alegre", "Belém", "Goiânia", "Guarulhos", "Campinas", "São Luís", "São Gonçalo", "Maceió", "Duque de Caxias", "Natal", "Campo Grande"]
    },
    {
        name: "Argentina",
        iso2: "AR",
        dial_code: "+54",
        cities: ["Buenos Aires", "Córdoba", "Rosario", "Mendoza", "La Plata", "San Miguel de Tucumán", "Mar del Plata", "Salta", "Santa Fe", "San Juan", "Resistencia", "Santiago del Estero", "Corrientes", "Bahía Blanca", "Posadas", "Paraná", "Neuquén", "Formosa", "San Salvador de Jujuy", "La Rioja"]
    },
    {
        name: "Mexico",
        iso2: "MX",
        dial_code: "+52",
        cities: ["Mexico City", "Guadalajara", "Monterrey", "Puebla", "Tijuana", "León", "Juárez", "Zapopan", "Mérida", "San Luis Potosí", "Aguascalientes", "Hermosillo", "Saltillo", "Mexicali", "Culiacán", "Guadalupe", "Acapulco", "Tlalnepantla", "Cancún", "Querétaro"]
    },
    {
        name: "Chile",
        iso2: "CL",
        dial_code: "+56",
        cities: ["Santiago", "Valparaíso", "Concepción", "La Serena", "Antofagasta", "Temuco", "Rancagua", "Talca", "Arica", "Chillán", "Iquique", "Los Ángeles", "Puerto Montt", "Coquimbo", "Osorno", "Valdivia", "Punta Arenas", "Quillota", "Quilpué", "Viña del Mar"]
    },
    {
        name: "Colombia",
        iso2: "CO",
        dial_code: "+57",
        cities: ["Bogotá", "Medellín", "Cali", "Barranquilla", "Cartagena", "Cúcuta", "Bucaramanga", "Pereira", "Santa Marta", "Ibagué", "Pasto", "Manizales", "Neiva", "Villavicencio", "Armenia", "Valledupar", "Montería", "Sincelejo", "Popayán", "Buenaventura"]
    },
    {
        name: "South Africa",
        iso2: "ZA",
        dial_code: "+27",
        cities: ["Johannesburg", "Cape Town", "Durban", "Pretoria", "Port Elizabeth", "Pietermaritzburg", "Benoni", "Tembisa", "East London", "Vereeniging", "Bloemfontein", "Boksburg", "Welkom", "Newcastle", "Krugersdorp", "Diepsloot", "Botshabelo", "Brakpan", "Witbank", "Richards Bay"]
    },
    {
        name: "Egypt",
        iso2: "EG",
        dial_code: "+20",
        cities: ["Cairo", "Alexandria", "Giza", "Shubra El-Kheima", "Port Said", "Suez", "Luxor", "Mansoura", "El-Mahalla El-Kubra", "Tanta", "Asyut", "Ismailia", "Fayyum", "Zagazig", "Aswan", "Damietta", "Damanhur", "Minya", "Beni Suef", "Qena"]
    },
    {
        name: "Nigeria",
        iso2: "NG",
        dial_code: "+234",
        cities: ["Lagos", "Kano", "Ibadan", "Kaduna", "Port Harcourt", "Benin City", "Maiduguri", "Zaria", "Aba", "Jos", "Ilorin", "Oyo", "Enugu", "Abeokuta", "Abuja", "Sokoto", "Onitsha", "Warri", "Ebute Ikorodu", "Okene"]
    },
    {
        name: "Kenya",
        iso2: "KE",
        dial_code: "+254",
        cities: ["Nairobi", "Mombasa", "Nakuru", "Ruiru", "Eldoret", "Kisumu", "Kikuyu", "Kangundo-Tala", "Malindi", "Naivasha", "Kitui", "Machakos", "Thika", "Athi River", "Karuri", "Nyeri", "Meru", "Kericho", "Kakamega", "Bungoma"]
    },
    {
        name: "Saudi Arabia",
        iso2: "SA",
        dial_code: "+966",
        cities: ["Riyadh", "Jeddah", "Mecca", "Medina", "Dammam", "Taif", "Tabuk", "Buraidah", "Khamis Mushait", "Al Hufuf", "Hafar Al-Batin", "Jubail", "Al-Khobar", "Abha", "Yanbu", "Al Qatif", "Khobar", "Najran", "Ha'il", "Al-Ahsa"]
    },
    {
        name: "United Arab Emirates",
        iso2: "AE",
        dial_code: "+971",
        cities: ["Dubai", "Abu Dhabi", "Sharjah", "Al Ain", "Ajman", "Ras Al Khaimah", "Fujairah", "Umm Al Quwain", "Khor Fakkan", "Dibba Al-Fujairah", "Dibba Al-Hisn", "Dhaid", "Jebel Ali", "Ruwais", "Ar-Rams", "Ghayathi", "Madinat Zayed", "Al Jazirah Al Hamra", "Kalba", "Hatta"]
    },
    {
        name: "Israel",
        iso2: "IL",
        dial_code: "+972",
        cities: ["Jerusalem", "Tel Aviv", "Haifa", "Rishon LeZion", "Petah Tikva", "Ashdod", "Netanya", "Be'er Sheva", "Holon", "Bnei Brak", "Ramat Gan", "Rehovot", "Bat Yam", "Ashkelon", "Herzliya", "Kfar Saba", "Hadera", "Modi'in-Maccabim-Re'ut", "Nazareth", "Lod"]
    },
    {
        name: "Singapore",
        iso2: "SG",
        dial_code: "+65",
        cities: ["Singapore", "Woodlands", "Tampines", "Jurong West", "Bedok", "Hougang", "Sengkang", "Punggol", "Yishun", "Choa Chu Kang", "Ang Mo Kio", "Pasir Ris", "Bukit Batok", "Bukit Panjang", "Sembawang", "Queenstown", "Toa Payoh", "Clementi", "Kallang", "Serangoon"]
    },
    {
        name: "Malaysia",
        iso2: "MY",
        dial_code: "+60",
        cities: ["Kuala Lumpur", "George Town", "Ipoh", "Shah Alam", "Petaling Jaya", "Johor Bahru", "Malacca City", "Kuching", "Kota Kinabalu", "Seremban", "Kuantan", "Klang", "Subang Jaya", "Kota Bharu", "Sandakan", "Kuala Terengganu", "Alor Setar", "Miri", "Taiping", "Batu Pahat"]
    },
    {
        name: "Thailand",
        iso2: "TH",
        dial_code: "+66",
        cities: ["Bangkok", "Samut Prakan", "Nonthaburi", "Chiang Mai", "Hat Yai", "Pak Kret", "Nakhon Ratchasima", "Chon Buri", "Lampang", "Surat Thani", "Udon Thani", "Khon Kaen", "Phuket", "Nakhon Si Thammarat", "Pattaya", "Saraburi", "Rayong", "Songkhla", "Phitsanulok", "Yala"]
    },
    {
        name: "Vietnam",
        iso2: "VN",
        dial_code: "+84",
        cities: ["Ho Chi Minh City", "Hanoi", "Hai Phong", "Da Nang", "Can Tho", "Bien Hoa", "Vung Tau", "Hue", "Nha Trang", "Buon Ma Thuot", "Phan Thiet", "Cam Ranh", "Vinh", "My Tho", "Da Lat", "Long Xuyen", "Thai Nguyen", "Quy Nhon", "Thai Binh", "Rach Gia"]
    },
    {
        name: "Philippines",
        iso2: "PH",
        dial_code: "+63",
        cities: ["Quezon City", "Manila", "Davao City", "Caloocan", "Cebu City", "Zamboanga City", "Taguig", "Antipolo", "Pasig", "Cagayan de Oro", "Parañaque", "Valenzuela", "Dasmariñas", "Las Piñas", "Makati", "Bacolod", "General Santos", "Muntinlupa", "Iloilo City", "Marikina"]
    },
    {
        name: "Indonesia",
        iso2: "ID",
        dial_code: "+62",
        cities: ["Jakarta", "Surabaya", "Bandung", "Bekasi", "Medan", "Tangerang", "Depok", "Semarang", "Palembang", "Makassar", "South Tangerang", "Batam", "Bogor", "Pekanbaru", "Bandar Lampung", "Padang", "Malang", "Denpasar", "Samarinda", "Tasikmalaya"]
    }
];

// Helper function to get country by name
export const getCountryByName = (name) => {
    return countriesData.find(country => country.name === name);
};

// Helper function to get all countries
export const getAllCountries = () => {
    return countriesData;
};

// Helper function to get cities for a country
export const getCitiesByCountry = (countryName) => {
    const country = getCountryByName(countryName);
    return country ? country.cities : [];
};

// Helper function to get dial code for a country
export const getDialCodeByCountry = (countryName) => {
    const country = getCountryByName(countryName);
    return country ? country.dial_code : '';
};
